import { html } from 'lit-html';
import { getAssetsUrlBase } from '../../../models/common/static_resource_util';


const ReviewStarIconsMaxCount = 5;

/**
 * レビュー星アイコン群生成
 * @param reviewPoint レビュー評価ポイント
 */
export const ReviewStarIcons = (reviewPoint: number) => {
  const StartIcons = [] as any;
  for (
    let starIconPositionNumber = 1;
    starIconPositionNumber < ReviewStarIconsMaxCount + 1;
    starIconPositionNumber++
  ) {
    StartIcons.push(
      html`<span class="a-icon -size16">${StarIcon(reviewPoint, starIconPositionNumber)}</span>`
    );
  }
  return html`${StartIcons}`;
};

/**
 * 星アイコン(単品)
 * 星の位置とレビュー評価ポイントを判定して星画像を返却する
 * @param reviewPoint レビューポイント
 * @param starIconPositionNumber 星アイコン番号
 */
const StarIcon = (reviewPoint: number, starIconPositionNumber: number) => {
  if (reviewPoint - starIconPositionNumber >= 0) {
    return html`<img class="a-icon_img" src="${getAssetsUrlBase() + "images/icon_star_fill.svg"}" alt="" width="16" height="16" />`;
  }
  if (reviewPoint - starIconPositionNumber >= -0.5) {
    return html`<img class="a-icon_img" src="${getAssetsUrlBase() + "images/icon_star_half.svg"}" alt="" width="16" height="16" />`;
  }
  return html`<img class="a-icon_img" src="${getAssetsUrlBase() + "images/icon_star_none.svg"}" alt="" width="16" height="16" />`;
};
